// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchBlock_container_2TXML","buttonOpen":"SearchBlock_buttonOpen_yJ_Sb"};